import { AUTH, CLOSE_SOCKET, CREATE_SOCKET, FETCH_HISTORIC_NOTIFICATIONS, FETCH_MORE_HISTORIC_NOTIFICATIONS, LOGOUT, NOTIFICATION_FROM_SOCKET, REPOPULATE, SHOW_CHAT, SHOW_CHAT_NOTIFICATIONS, SHOW_NOTIFICATIONS, UPDATE_PROFILE } from '../constants/actionTypes';

const chatUIReducer = (state = {showChat: false, chatNotification: null}, action) => {

    /*For UI related events to chat. Such as showing new message notifications
        Showing the chat UI itself, etc. 
   */

    switch (action.type) {
        
        case SHOW_CHAT_NOTIFICATIONS: //data from this is picked up in PopUpNotifications.jsx

            return {
                ...state,
                chatNotification: action.notification //one at a time - for now
            }

        case SHOW_CHAT:

            return {
                ...state,
                showChat: action.show
            }

        default:
            return state; 
    }
}

export default chatUIReducer; 